import React from "react";
import { Link, BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";
import Information from "./Information";
import Projects from "./Projects";
import Skills from "./Skills";
import AboutMeHome from "./AboutMeHome";
import ContactsHome from "./ContactsHome";
import Footer from "./Footer";
import { BsArrowRight } from "react-icons/bs";
// import { Link } from "react-router-dom";

const Home = () => {
  return (
    <>
      <div
        style={{
          display: "flex",
          gap: "2%",
          marginLeft: "3%",
          height: "3%",
        }}
      >
        <Sidebar />

        <div style={{ display: "block", width: "90%" }}>
          <Navbar />
          <Information />
          <Projects />
          <Skills />
          <div>
            <AboutMeHome />
            <button
              style={{
                display: "flex",
                alignItems: "center",
                color: "white",
                marginLeft: "5%",
                border: "2px solid #C778DD",
                padding:'2% 7%'
              }}
            >
              <Link to="/about">Read more</Link> <BsArrowRight />
            </button>
          </div>

          <ContactsHome />
        </div>
      </div>
      <Footer />
    </>
  );
};
export default Home;
